var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-contact-container offer", attrs: { fluid: "" } },
    [
      !_vm.pushSent
        ? _c(
            "b-row",
            { staticClass: "p-0" },
            [
              _c("b-col", { staticClass: "p-0", attrs: { cols: "12" } }, [
                _c("h3", { staticClass: "cd-contact-headline" }, [
                  _vm._v("Persönliche Daten")
                ])
              ]),
              _c("b-col", { staticClass: "p-0" }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "cd-form-container" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "salutation" }
                              },
                              [_vm._v("Anrede*")]
                            ),
                            _c("v-select", {
                              class:
                                _vm.$v.salutation.$invalid && _vm.firstSubmit
                                  ? "is-invalid"
                                  : "",
                              attrs: {
                                name: "salutation",
                                label: "label",
                                placeholder: "Anrede wählen",
                                options: _vm.salutations
                              },
                              model: {
                                value: _vm.salutation,
                                callback: function($$v) {
                                  _vm.salutation = $$v
                                },
                                expression: "salutation"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "company" }
                              },
                              [_vm._v("Firma")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: { name: "company", placeholder: "Firma" },
                              model: {
                                value: _vm.company,
                                callback: function($$v) {
                                  _vm.company = $$v
                                },
                                expression: "company"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "cd-form-row-start",
                            attrs: { md: "12", lg: "6" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "firstName" }
                              },
                              [_vm._v("Vorname*")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: {
                                state:
                                  _vm.$v.firstName.$invalid && _vm.firstSubmit
                                    ? false
                                    : null,
                                name: "firstName",
                                placeholder: "Vorname"
                              },
                              model: {
                                value: _vm.firstName,
                                callback: function($$v) {
                                  _vm.firstName = $$v
                                },
                                expression: "firstName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "cd-form-row-end",
                            attrs: { md: "12", lg: "6" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "lastName" }
                              },
                              [_vm._v("Nachname*")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: {
                                state:
                                  _vm.$v.lastName.$invalid && _vm.firstSubmit
                                    ? false
                                    : null,
                                placeholder: "Nachname"
                              },
                              model: {
                                value: _vm.lastName,
                                callback: function($$v) {
                                  _vm.lastName = $$v
                                },
                                expression: "lastName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "cd-form-row-start",
                            attrs: { md: "12", lg: "6" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "zipCode" }
                              },
                              [_vm._v("PLZ*")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: {
                                state:
                                  _vm.$v.zipCode.$invalid && _vm.firstSubmit
                                    ? false
                                    : null,
                                name: "zipCode",
                                placeholder: "PLZ"
                              },
                              model: {
                                value: _vm.zipCode,
                                callback: function($$v) {
                                  _vm.zipCode = $$v
                                },
                                expression: "zipCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "cd-form-row-end",
                            attrs: { md: "12", lg: "6" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "city" }
                              },
                              [_vm._v("Ort*")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: {
                                state:
                                  _vm.$v.city.$invalid && _vm.firstSubmit
                                    ? false
                                    : null,
                                placeholder: "Ort"
                              },
                              model: {
                                value: _vm.city,
                                callback: function($$v) {
                                  _vm.city = $$v
                                },
                                expression: "city"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "email" }
                              },
                              [_vm._v("E-Mail*")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: {
                                state:
                                  _vm.$v.email.$invalid && _vm.firstSubmit
                                    ? false
                                    : null,
                                placeholder: "E-Mail"
                              },
                              model: {
                                value: _vm.email,
                                callback: function($$v) {
                                  _vm.email = $$v
                                },
                                expression: "email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "cd-form-label",
                                attrs: { for: "phone" }
                              },
                              [_vm._v("Telefonnummer")]
                            ),
                            _c("b-form-input", {
                              staticClass: "cd-form-input",
                              attrs: { placeholder: "Telefonnummer" },
                              model: {
                                value: _vm.phone,
                                callback: function($$v) {
                                  _vm.phone = $$v
                                },
                                expression: "phone"
                              }
                            })
                          ],
                          1
                        ),
                        _c("b-col", [
                          _c("p", { staticClass: "cd-offer-subnote" }, [
                            _vm._v("Mit * markierte Felder sind Pflichtfelder")
                          ])
                        ]),
                        _c(
                          "b-col",
                          {
                            staticClass: "privacy",
                            class:
                              _vm.$v.privacyPolicyAccepted.$invalid &&
                              _vm.firstSubmit
                                ? "is-checkbox-invalid"
                                : "",
                            attrs: { cols: "12" }
                          },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  id: "privacyPolicyAccepted",
                                  name: "privacyPolicyAccepted"
                                },
                                model: {
                                  value: _vm.privacyPolicyAccepted,
                                  callback: function($$v) {
                                    _vm.privacyPolicyAccepted = $$v
                                  },
                                  expression: "privacyPolicyAccepted"
                                }
                              },
                              [
                                _vm._v(
                                  " * " + _vm._s(_vm.privacyPolicyText) + " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            class:
                              _vm.$v.privacyPolicyAcceptedAdditional.$invalid &&
                              _vm.firstSubmit
                                ? "is-checkbox-invalid"
                                : "",
                            attrs: { sm: "12", md: "12", lg: "12", xl: "12" }
                          },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  id: "privacyPolicyAcceptedAdditional",
                                  name: "privacyPolicyAcceptedAdditional"
                                },
                                model: {
                                  value: _vm.privacyPolicyAcceptedAdditional,
                                  callback: function($$v) {
                                    _vm.privacyPolicyAcceptedAdditional = $$v
                                  },
                                  expression: "privacyPolicyAcceptedAdditional"
                                }
                              },
                              [
                                _vm._v(
                                  " * Mir ist bekannt, dass ich weitere Informationen (inklusive der vollständigen Händlerliste) in der Datenschutzerklärung "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.privacyPolicyUrl,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Datenschutzhinweis")]
                                ),
                                _vm._v(
                                  " erhalte. Diese habe ich vollständig gelesen. "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.pushSent
        ? _c(
            "b-row",
            [
              _c("b-col", [
                _vm._v(
                  " Vielen Dank für Ihre Anfrage, die jetzt von uns geprüft wird. "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c("b-modal", {
        attrs: {
          static: "",
          scrollable: "",
          id: "cd-newconfiguration-modal",
          size: "lg",
          title: "Ihre Konfiguration ist abgeschlossen."
        },
        on: { ok: _vm.createNewConfiguration },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              return [
                _c("b-container", [
                  _c("p", [
                    _vm._v(
                      "Ihre Konfiguration wurde bereits erfolgreich übermittelt. Möchten Sie eine neue Konfiguration starten?"
                    )
                  ])
                ])
              ]
            }
          },
          {
            key: "modal-footer",
            fn: function(ref) {
              var ok = ref.ok
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "cd-button",
                    attrs: { size: "sm" },
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [_vm._v("Neue Konfiguration")]
                )
              ]
            }
          }
        ])
      }),
      _c(
        "b-container",
        { staticClass: "d-block d-xs-block d-sm-block d-md-block d-lg-none" },
        [_c("SidebarButton")],
        1
      ),
      _c(
        "b-container",
        { staticClass: "d-block d-xs-block d-sm-block d-md-block d-lg-none" },
        [
          _c(
            "b-row",
            { staticClass: "cd-offer-container" },
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "cd-offer-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.downloadOfferPdf()
                      }
                    }
                  },
                  [_vm._v("Angebot drucken")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }